import { Chip } from '@mui/material';
import type { ChipProps } from '@mui/material';
import React from 'react';
import { labelColors } from '../../theme';

interface ClassificationChipProps {
  value: string;
  sx?: ChipProps['sx'];
}

export const PURPLE_SX = {
  borderColor: '#9c27b0',
  color: '#9c27b0',
};

const ClassificationChip: React.FC<ClassificationChipProps> = ({ value, sx }) => {
  const colorConfig = labelColors[value as keyof typeof labelColors];
  const isPurple = colorConfig?.chip === 'purple';
  const chipColor: ChipProps['color'] = isPurple
    ? undefined
    : ((colorConfig?.chip as ChipProps['color'] | undefined) ?? 'default');
  return (
    <Chip
      label={value.charAt(0).toUpperCase() + value.slice(1)}
      size="small"
      color={chipColor}
      variant="outlined"
      sx={isPurple ? { ...PURPLE_SX, ...sx } : sx}
    />
  );
};

export default ClassificationChip;
